export default "__VITE_ASSET__BisXjnO4__"